import ContaService from "@/services/ContaService";

export const conta = {
  namespaced: true,
  state: {
    conta: {},
  },
  actions: {
    getConta({ commit }, payload) {
      return ContaService.GetConta(payload).then(
        (conta) => {
          return Promise.resolve(conta);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getAllConta({ commit }) {
      return ContaService.GetAllConta().then(
        (conta) => {
          return Promise.resolve(conta);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postConta({ commit }, payload) {
      return ContaService.PostConta(payload).then(
        (conta) => {
          return Promise.resolve(conta);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putConta({ commit }, payload) {
      return ContaService.PutConta(payload).then(
        (conta) => {
          return Promise.resolve(conta);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteConta({ commit }, payload) {
      return ContaService.DeleteConta(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getContaOData({ commit }, payload) {
      return ContaService.GetContaOData(payload).then(
        (conta) => {
          return Promise.resolve(conta);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default conta;
